import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type MediaState = {
  dataMedia: MediaImageType[];
};

export const mediaInitialState: MediaState = {
  dataMedia: [],
};

export const slice = createSlice({
  name: 'media',
  initialState: mediaInitialState,
  reducers: {
    setListMediaAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: MediaImageType[];
      }>,
    ) {
      state.dataMedia = payload.data;
    },
  },
});

export const { setListMediaAction } = slice.actions;

export default slice.reducer;
